"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandIcon = void 0;
var expandIcon = "\n            <span class=\"MuiIconButton-label\">\n                <svg class=\"MuiSvgIcon-root\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" tabindex=\"-1\" title=\"Fullscreen\" data-ga-event-category=\"material-icons\" data-ga-event-action=\"click\" data-ga-event-label=\"Fullscreen\"><path d=\"M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z\"></path></svg>\n            </span>\n           <span class=\"MuiTouchRipple-root\"></span>\n        ";
exports.expandIcon = expandIcon;